export const validateJsonField = (value) => {
  try {
    value && JSON.parse(value);
    return undefined;
  } catch (e) {
    return 'Invalid JSON format. Please enter values in JSON format, for example: {"limit":100}';
  }
};

export const validateInteger = (value) => {
  if (value === undefined || value === null || value === '') return undefined;
  return Number.isInteger(Number(value)) ? undefined : 'Must be a whole number';
};
